import * as React from 'react';
import { IStylingFirm } from '../Entities';
import { ButtonToolbar, Button, Label, ButtonGroup } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';

interface IStylingFirmsListRowProps {
    stylingFirm: IStylingFirm;
    editStylingFirm: (id: number) => void;
    viewlogs: (id: number) => void;
    deleteStylingFirm: (id: number) => void;
}

const StylingFirmsListRow = (props: IStylingFirmsListRowProps) => {
    return (
        <tr>
            <td>{props.stylingFirm.name}</td>
            <td className="tools">
                <ButtonToolbar className="pull-right btn-group-sm">
                    <ButtonGroup className="center">
                        <Button
                            onClick={() => props.editStylingFirm(props.stylingFirm.id)}
                            bsStyle="primary"
                        >
                            <i className="material-icons">edit</i>
                            {Translate('styling-firms/list/row/button-label/edit')}
                        </Button>
                        <Button onClick={() => props.viewlogs(props.stylingFirm.id)} bsStyle="info">
                            <i className="material-icons">list</i>{' '}
                            {Translate('styling-firms/list/row/button-label/logs')}
                        </Button>
                        <Button
                            onClick={() => props.deleteStylingFirm(props.stylingFirm.id)}
                            bsStyle="danger"
                        >
                            <i className="material-icons">delete</i>{' '}
                            {Translate('styling-firms/list/row/button-label/delete')}
                        </Button>
                    </ButtonGroup>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default StylingFirmsListRow;
